const env = {
    BASE_URL_API: "https://nbra-pr-lppdev-usea-001-app.azurewebsites.net/api",
    BASE_URL_TPMDigital: "https://tpmdigitalnestle.azurewebsites.net",
    BASE_URL_MapaEtiquetas: "https://nbra-pr-mapaetiquetadev-app.azurewebsites.net",
    BASE_URL_MATRIZ: "https://nbra-pr-matrizdev-usea-001-app.azurewebsites.net",
    urlBiTickets: "https://app.powerbi.com/reportEmbed?reportId=de57b4c2-da23-4adf-9937-67acf9aed916&autoAuth=true&ctid=12a3af23-a769-4654-847f-958f3d479f4a",
    urlBI: "https://app.powerbi.com/reportEmbed?reportId=6c955760-49d8-42bd-9220-12d5bf7f895b&autoAuth=true&ctid=6bec7486-5aae-4cfa-baa9-c8a2b7ba967d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWJyYXppbC1zb3V0aC1iLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D",
    clientId: "6483ca20-9cff-423d-b60b-b56bae8b6234",
    authority: "https://login.microsoftonline.com/b96d8f26-7b17-4990-b791-16e3f45b5741",
    matriz_URL: "https://nbra-pr-matrizdev-usea-001-app.azurewebsites.net/",
    STORAGE_SECRET: "agllknALDLAKSd234092834!@#",
    STORAGE_PREFIX: "@prefix",
    SPEECH_REGION: "centralus",
    urlNivel: "https://nestleunivemblobstorage.blob.core.windows.net/signatures/Blibloteca_NivelAcesso.xlsx",
    ENVIRONMENT: "Staging"
}

export default env;